import { SharedUiModule } from '@enauka/shared/ui';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUtilModule } from '@enauka/shared/util';
import { PodgladTeoriiDialogComponent } from './podglad-teorii-dialog/podglad-teorii-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUtilModule,
    SharedUiModule
  ],
  declarations: [
    PodgladTeoriiDialogComponent
  ],
  exports: [
    PodgladTeoriiDialogComponent
  ]

})
export class DialogiModule { }
